export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12110.89bcc0f5.jpg";